import "./BannerStyles.css";

import React from 'react'

import { Link, NavLink } from "react-router-dom";

import banner1 from "../assets/banner1.jpg";

const Banner = () => {
  return (
    <div className="banner">
        <div className="mask">
            <img className="banner1" src={banner1} alt="Banner of a office"/>
        </div>
        <div className="content">
            <p>¡HOLA, SOY ARTURO URBANOS VARA! 👋</p>
            <h1><span style={{color:"#2FA9AA"}}>Full-Stack</span> <span style={{color:"#98CD7A"}}>Developer</span></h1>
            <span>Me enfoco al desarrollo web con JavaScript, PHP, HTML, CSS, Bootstrap, React, Angular, node.js y más 💕 </span>
            <div className="buttons">
            <NavLink to="https://www.dropbox.com/s/yfbsx9njkplufi9/CV_ArturoUrbanosVara.pdf?raw=1" target={"_blank"} className="btn">Mi CV</NavLink>
            <Link to="/sobre-mi" className="btn btn-light">Conóceme</Link>
            </div>
        </div>
    </div>
  )
}

export default Banner